// scroll-effect.js

document.addEventListener("DOMContentLoaded", () => {
  const overlapSection = document.getElementById("overlap-section");
  const slidingImages = document.getElementById("sliding-images");

  // Store the initial top offset of the overlap section
  let sectionOffsetTop = overlapSection.offsetTop;

  // The total scroll distance over which the images will animate
  // This should match the section height (200vh) to ensure smooth transition
  const totalImageAnimationDistance = 2 * window.innerHeight;

  window.addEventListener("scroll", () => {
    // Calculate how much the user has scrolled *within* the overlap section
    // The animation starts when the top of the overlapSection aligns with the top of the viewport
    // (i.e., when sticky content becomes active).
    const scrollFromSectionTop = Math.max(0, window.scrollY - sectionOffsetTop);

    // Calculate scroll progress (0 to 1) over the defined animation distance
    // This progress drives the image's vertical movement.
    let scrollProgress = Math.min(
      1,
      scrollFromSectionTop / totalImageAnimationDistance
    );

    // Calculate the translateY value for the sliding images.
    // When scrollProgress is 0: translateY should be +100vh (off-screen bottom).
    // When scrollProgress is 0.5: translateY should be 0 (images centered, covering content).
    // When scrollProgress is 1: translateY should be -100vh (off-screen top).
    // The range of translateY is from +100vh to -100vh, which is 200vh.
    // This ensures images complete animation exactly when section ends.
    const translateY =
      window.innerHeight - scrollProgress * totalImageAnimationDistance;

    // Apply the transform to the sliding images div
    slidingImages.style.transform = `translateY(${translateY}px)`;

    // Hide images completely when animation is done to ensure clean transition
    if (scrollProgress >= 1) {
      slidingImages.style.opacity = "0";
    } else {
      slidingImages.style.opacity = "1";
    }
  });

  // Recalculate sectionOffsetTop on window resize to ensure correct animation start point
  window.addEventListener("resize", () => {
    sectionOffsetTop = overlapSection.offsetTop;
    // Trigger a redraw on resize to adjust image position if necessary
    window.dispatchEvent(new Event("scroll"));
  });

  // Trigger initial scroll event to set correct image position on load
  window.dispatchEvent(new Event("scroll"));
});
